module.exports = __webpack_public_path__ + "img/help-circle.8871e941.svg";